import React from 'react';
import { LTText, LTTooltip } from '@lambdatestincprivate/lt-components';
import styles from './AIRca.module.css';

const GrayDashes = ({ count = 1 }) => (
  <div style={{ display: 'flex', gap: '8px' }}>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={`dash-${i}`}
        style={{
          width: '6px',
          height: '2px',
          backgroundColor: '#6E7781',
          borderRadius: '1px',
        }}
      />
    ))}
  </div>
);

const ErrorTrendChart = ({ errorTrendsData, title = 'Error Trends (Global)' }) => {
  if (!errorTrendsData || !Array.isArray(errorTrendsData) || errorTrendsData.length === 0) {
    return null;
  }

  const trendData = errorTrendsData.map((item) => ({
    date: item.x,
    occurrences: item.y ?? 0,
  }));

  const maxOccurrences = Math.max(...trendData.map((item) => item.occurrences));
  const minHeight = 15;
  const maxHeight = 30;

  const tooltipText =
    'Show the occurrence of this failure type at a global level. How many times this failure type has occurred over the last 10 days';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '2px', width: '150px', flexShrink: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', width: '100%' }}>
        <LTTooltip text={tooltipText}>
          <LTText text={title} color="text.muted" variant={LTText.TextVariant.SMALL_REGULAR} />
        </LTTooltip>
        <LTText text="10" variant={LTText.TextVariant.SMALL_BOLD} />
        <LTText text="d" variant={LTText.TextVariant.SMALL_REGULAR} />
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '7px', position: 'relative' }}>
        <GrayDashes count={1} />
        {trendData.map((item, index) => {
          let barHeight = 0;
          if (item.occurrences > 0) {
            const ratio = maxOccurrences > 0 ? item.occurrences / maxOccurrences : 0;
            barHeight = Math.max(minHeight, ratio * maxHeight);
          }

          return (
            <LTTooltip key={index} text={`No of Occurrences: ${item.occurrences}\nDate: ${item.date}`}>
              <div
                className={styles.trendBar}
                style={{
                  width: `${Math.min(6, Math.max(8, 55 / trendData.length))}px`,
                  height: `${barHeight}px`,
                  minHeight: '4px',
                }}
              />
            </LTTooltip>
          );
        })}
        <GrayDashes count={1} />
      </div>
    </div>
  );
};

export default ErrorTrendChart;
